export const GET_FILE_BY_AREA = "GET_FILE_BY_AREA"
export const GET_FILE_BY_AREA_SUCCESS = "GET_FILE_BY_AREA_SUCCESS"
export const GET_FILE_BY_AREA_FAIL = "GET_FILE_BY_AREA_FAIL"

export const UPLOAD_FILE = "UPLOAD_FILE"
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS"
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL"
//DOWNLOAD FILES
export const DOWNLOAD_FILE = "DOWNLOAD_FILE"
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS"
export const DOWNLOAD_FILE_FAIL = "DOWNLOAD_FILE_FAIL"
//CLEAN DATA
export const CLEAN_VIEW = "CLEAN_VIEW"
//DOWNLOAD FILES
export const SEND_EMAIL_SUPPLIER = "SEND_EMAIL_SUPPLIER"
export const SEND_EMAIL_SUPPLIER_SUCCESS = "SEND_EMAIL_SUPPLIER_SUCCESS"
export const SEND_EMAIL_SUPPLIER_FAIL = "SEND_EMAIL_SUPPLIER_FAIL"

//DELETE FILES
export const DELETE_FILE_UPLOAD = "DELETE_FILE_UPLOAD"
export const DELETE_FILE_UPLOAD_SUCCESS = "DELETE_FILE_UPLOAD_SUCCESS"
export const DELETE_FILE_UPLOAD_FAIL = "DELETE_FILE_UPLOAD_FAIL"
